<template>
  <v-card class="mx-auto" :max-width="$vuetify.breakpoint.sm ? '500' : '344'">
    <v-img
      src="https://images.unsplash.com/photo-1536148935331-408321065b18?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=633&q=80"
      height="200px"
    ></v-img>

    <v-card-title>
      <vue-typed-js :strings="['Why?']" :typeSpeed="80">
        <span class="typing"></span>
      </vue-typed-js>
    </v-card-title>
    <v-card-text class="text-justify">
      I have extensive experience in a working environment on both the
      development side as well as the designing side. I am also capable of
      working full stack as I have experience with in on my personal projects. I
      am versatile, being able to do more than just web development. I am also a
      team player that can work independent if necessary so I would be a perfect
      fit for any team there is.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        class="font-weight-black"
        @click="$store.commit('previousPage')"
        >Previous</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
